export default "__VITE_ASSET__Bvy4HBuq__"